import { ReactNode } from "react";

export const NavButton = ({
	icon,
	label,
	isActive,
	showLabel = true,
	badge = 0
}: {
	icon?: ReactNode;
	label: string;
	isActive: boolean;
	showLabel?: boolean;
	badge?: number;
}) => (
	<div
		className={`
				flex flex-row items-center
				text-sm font-medium
				transition-all duration-200
				gap-3
				focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-800
				px-4 py-2.5 mx-2 my-0.5
				rounded-xl
				w-[calc(100%-1rem)]
				${isActive
					? "bg-gradient-to-r from-primary/15 to-primary/5 text-primary dark:from-white/10 dark:to-white/5 dark:text-white shadow-sm"
					: "text-gray-600 dark:text-gray-300 hover:bg-gray-100/80 dark:hover:bg-white/5 hover:text-gray-900 dark:hover:text-white"
				}
			`}
	>
		{icon && (
			<div className={`relative flex items-center justify-center ${isActive ? "drop-shadow-sm" : ""}`}>
				{icon}
				{!showLabel && badge > 0 && (
					<span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-red-500 border border-white dark:border-gray-800" />
				)}
			</div>
		)}
		{showLabel && <div className="leading-tight truncate">{label}</div>}
		{showLabel && badge > 0 && (
			<div className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
				{badge > 99 ? "99+" : badge}
			</div>
		)}
		{isActive && (
			<div className={`${badge > 0 && showLabel ? "" : "ml-auto"} w-1.5 h-1.5 rounded-full bg-primary dark:bg-white`} />
		)}
	</div>
);
